/**
 * filterListByKey
 * @param {Object[]} list - A list of objects
 * @param {string[]} target - A list of status to accept
 * @param {string} key - dedicated value
 * @return {Object[]} - A list of filtered object
 * @example
 *  const list = [{status: 'A'}, {status: 'B'}]
 *  const target = ['A']
 *  const key = "status"
 *  filterListByKey(list, target, key) => [{status: 'A'}]
 */
export const filterListByKey = (list, target, key) => {
  return list.filter(data => target.includes(data[key]));
};

export const getFilterOptions = ({ options, fetchOptions }) => {
  if ((!options || options.length < 1) && typeof fetchOptions === 'function') {
    fetchOptions();
  }
};
